import getters from './getters'
import mutations from './mutations'
import actions from './actions'
const state = {
  coPropList: '',
  meterList: '',
  lotList: '',
  addressList: '',
  lotPDFData: '',
  previousUnitData: '',
  landingPageCount: '',
  completedSessionHome: ''
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/coprops/index.js